import { useCreateComparison } from '@dc-shared-web/hooks/api/comparison/useCreateComparison'
import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import type {
  CrunchData,
  DocumentSvcCrunches,
} from '@/dc-shared-web/src/hooks/api/document/types'
import type {
  CreateComparisonParams,
  VCCardProps,
} from '@/dc-shared-web/src/hooks/api/comparison/types'
import { ComparisonStatus } from '@/dc-shared-web/src/hooks/api/comparison/types'

interface UseComparisonCreationProps {
  onProcessingComparisonAdded: (comparison: VCCardProps) => void
  onSuccess?: () => void
}

export function useComparisonCreation({
  onProcessingComparisonAdded,
  onSuccess,
}: UseComparisonCreationProps) {
  const { user } = useAuth()
  const { mutateAsync: createComparison, isError: isCreateComparisonError } =
    useCreateComparison()

  const createProcessingCard = (
    newComparison: CreateComparisonParams,
    previousVersion: CrunchData,
    newFileName: string
  ) => {
    const processingCard: VCCardProps = {
      uuid: newComparison.crunch_uuid,
      version_a_name: previousVersion?.label ?? '',
      version_a_guid: newComparison.doc_guid_a,
      version_b_name: newFileName ?? '',
      version_b_guid: newComparison.doc_guid_b,
      created_on: '',
      crunched_by: newComparison.user_uuid,
      total_changes: 0,
      status: ComparisonStatus.PROCESSING,
    }
    onProcessingComparisonAdded(processingCard)
  }

  const handleComparison = async (
    newVersion: DocumentSvcCrunches,
    previousVersion: CrunchData,
    newFileName: string
  ) => {
    const newComparison: CreateComparisonParams = {
      doc_guid_a: previousVersion?.document_guid ?? '',
      doc_guid_b: newVersion.versions?.[newVersion.versions.length - 1] ?? '',
      crunch_uuid: newVersion.uuid ?? '',
      user_uuid: user.uuid ?? '',
      generate_new_analysis: false,
    }

    await createComparison(newComparison)
    createProcessingCard(newComparison, previousVersion, newFileName)
    onSuccess?.()
  }

  return {
    handleComparison,
    isCreateComparisonError,
  }
}
